import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=a13bc76e&scoped=true&"
var script = {}
import style0 from "./Property.vue?vue&type=style&index=0&id=a13bc76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13bc76e",
  null
  
)

export default component.exports